import { shallowMount } from "@vue/test-utils";
import BannerMasComodo from "@/components/core/custom/BannerMasComodo.vue";

describe("BannerMasComodo component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(BannerMasComodo);
  });

  it("Renders del component BannerMODOOferta", () => {
    expect(wrapper).toBeDefined();
  });

  it("Debe de establecer el valor por defecto", () => {
    expect(wrapper.text()).toContain("");
  });
});
